/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.WorldStreetsApi = factory(root.GisServerApis.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';

  /**
   * WorldStreets service.
   * @module api/WorldStreetsApi
   * @version 1.0.0
   */

  /**
   * Constructs a new WorldStreetsApi. 
   * @alias module:api/WorldStreetsApi
   * @class
   * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the getVectorTileByXyzV1 operation.
     * @callback module:api/WorldStreetsApi~getVectorTileByXyzV1Callback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get a World Streets vector tile by XYZ.
     * @param {Number} tileZ The Z value (zoom level) of the tile to get.
     * @param {Number} tileX The X value (matrix column) of the tile to get.
     * @param {Number} tileY The Y value (matrix row) of the tile to get.
     * @param {module:api/WorldStreetsApi~getVectorTileByXyzV1Callback} callback The callback function, accepting three arguments: error, data, response
     */
    this.getVectorTileByXyzV1 = function(tileZ, tileX, tileY, callback) {
      var postBody = null;

      // verify the required parameter 'tileZ' is set
      if (tileZ === undefined || tileZ === null) {
        throw new Error("Missing the required parameter 'tileZ' when calling getVectorTileByXyzV1");
      }

      // verify the required parameter 'tileX' is set
      if (tileX === undefined || tileX === null) {
        throw new Error("Missing the required parameter 'tileX' when calling getVectorTileByXyzV1");
      }

      // verify the required parameter 'tileY' is set
      if (tileY === undefined || tileY === null) {
        throw new Error("Missing the required parameter 'tileY' when calling getVectorTileByXyzV1");
      }


      var pathParams = {
        'tileZ': tileZ,
        'tileX': tileX,
        'tileY': tileY
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = [];
      var returnType = null;

      return this.apiClient.callApi(
        '/api/v1/world-streets/vector/{tileZ}/{tileX}/{tileY}', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));

